import React from 'react';
import { ImmersiveSlideShow } from 'Components/widgets/immersive-slideshow/ImmersiveSlideShow';
type Props = {
  media: Array<string>;
  nextLabel?: string;
  pictureAltLabel?: string;
  previousLabel?: string;
  size: ImmersiveSizeProps;
};
export const ProductImmersiveNarrow = ({
  media,
  nextLabel,
  pictureAltLabel,
  previousLabel,
  size,
}: Props) => (
  <ImmersiveSlideShow
    immersiveSize={size}
    media={media}
    nextLabel={nextLabel}
    pictureAltLabel={pictureAltLabel}
    previousLabel={previousLabel}
  />
);
